import script from "./Countdown.vue?vue&type=script&setup=true&lang=js"
export * from "./Countdown.vue?vue&type=script&setup=true&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=146d43ab&scoped=true&lang=css"

import exportComponent from "/Users/muhammadaziziabdulaziz/Documents/VueProject/reeqzan/izznina/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146d43ab"]])

export default __exports__